module.exports = __webpack_public_path__ + "assets/icon-calendar-round-bg.8af4a685.svg";